<main class="main-home-secton">
  <section class="slider-section">
    <div>
      <img
        class=""
        src="/assets\images\bg-banner-image.png"
        class="newbgimage"
        alt=""
      />
    </div>
    <div class="container py-5">
      <div class="row home-container-cont">
        <div class="col-lg-7 col-md-7 col-sm-6 col-12">
          <div class="incubators-div" style="margin: 5%">
            <img
              src="/assets\images\banner-white.png"
              class="img-full-width"
              alt=""
            />
            <p
              style="
                color: rgb(230, 224, 224);
                padding-top: 27px;
                font-size: 24px;
              "
              class="text-center"
            >
              The Home for Diversified and Largest Number of Incubation centres
              in the country
            </p>
            <div class="text-center mt-3">
              <button class="Partner-btn" (click)="scrollTo('incubator')">
                Connect With Incubator
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="card banner-card">
    <div class="container-fluid">
      <div class="row" *ngIf="homeList">
        <div class="col-lg-3 col-md-6 col-sm-6 col-12 banner-content">
          <span class="first-cont">{{ homeList.incubationCenters }}</span
          ><br />
          <span class="sec-cont">Incubation Centres</span>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 col-12 banner-content">
          <span class="first-cont">{{ homeList.sectorsFocused }}</span
          ><br />
          <span class="sec-cont">Sectors focused</span>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 col-12 banner-content">
          <span class="first-cont">{{ homeList.startupsIncubated }}</span
          ><br />
          <span class="sec-cont">Startups Incubated</span>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 col-12 banner-content">
          <span class="first-cont">{{ homeList.incubationSpace }}</span
          ><br />
          <span class="sec-cont">Incubation space</span>
        </div>
      </div>
      <div class="row" *ngIf="!homeList">
        <div class="col-lg-3 col-md-6 col-sm-6 col-12 banner-content">
          <span class="first-cont">124</span><br />
          <span class="sec-cont">Incubation Centres</span>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 col-12 banner-content">
          <span class="first-cont">30+</span><br />
          <span class="sec-cont">Sectors focused</span>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 col-12 banner-content">
          <span class="first-cont">2500+</span><br />
          <span class="sec-cont">Startups Incubated</span>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 col-12 banner-content">
          <span class="first-cont">32.23L+ sq.ft</span><br />
          <span class="sec-cont">Incubation space</span>
        </div>
      </div>
    </div>
  </div>
  <section class="about-section">
    <div class="container-fluid">
      <div class="row ecosys-first">
        <div class="col-12">
          <div class="mb-3">
            <h1 class="text-center new-title">
              Tamil Nadu Incubator Ecosystem
            </h1>
          </div>
        </div>

        <div class="col-lg-6 col-md-12 col-sm-12 col-12 ecosys-sidecont">
          <p>
            Incubators in Tamil Nadu cater to diverse sectors supporting
            startups right from their inception, creating values, jobs,
            generating revenue and achieving milestones. Through their network
            and expertise, incubators have helped startups secure funding worth
            millions of dollars, enabling them to scale and thrive.
          </p>
          <br />
          <p class="mt-2">
            With over 120+ incubators across 30 districts of the state, Tamil
            Nadu's incubator landscape is a testament to the state's commitment
            to fostering innovation and entrepreneurship. With its diverse range
            of players, impressive numbers, and focus on the future, this
            ecosystem is poised to play a vital role in propelling Tamil Nadu's
            economic and social progress.
          </p>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 col-12">
          <div class="text-center">
            <img
              style="width: 78%; margin: 57px; margin-left: 20px"
              src="assets/images/echo-sys-1.png"
              class="img-fluid about-img"
              alt=""
            />
          </div>
        </div>
        <div class="col-lg-12 col-md-6 col-sm-12 col-12">
          <div class="text-center echo-sys-2">
            <img
              src="assets/images/echo-sys-2.png"
              class="img-fluid about-img"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-map-section></app-map-section>
  <section class="form-section" id="incubator">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayoutAlign="center center"
            class=""
          >
            <mat-card class="section-card">
              <div class="text-center" style="margin: 5%; font-size: 30px">
                <h1>Connect With Incubator</h1>
              </div>
              <form
                [formGroup]="incubatorForm"
                (ngSubmit)="onSubmit()"
                fxLayout="column"
                fxLayoutGap="15px"
              >
                <mat-form-field
                  class="col-lg-6 col-md-6 col-sm-12"
                  appearance="outline"
                >
                  <mat-label>Name <span class="text-danger">*</span></mat-label>
                  <input
                    matInput
                    placeholder="Enter Your Name"
                    formControlName="name"
                    [ngClass]="{
                      'is-invalid': add.name.touched && add.name.errors
                    }"
                  />
                  <mat-error *ngIf="add.name.touched && add.name.errors">
                    <span *ngIf="add.name.errors.required"
                      >Incubator Name is required</span
                    >
                  </mat-error>
                </mat-form-field>
                <mat-form-field
                  class="col-lg-6 col-md-6 col-sm-12"
                  appearance="outline"
                >
                  <mat-label>Startup Name </mat-label>
                  <input
                    matInput
                    placeholder="Enter Your Name"
                    formControlName="startupName"
                    [ngClass]="{
                      'is-invalid':
                        add.startupName.touched && add.startupName.errors
                    }"
                  />
                </mat-form-field>
                <mat-form-field
                  class="col-lg-6 col-md-6 col-sm-12"
                  appearance="outline"
                >
                  <mat-label
                    >Email <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Your Email Id"
                    formControlName="email"
                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.]/g,'')"
                    type="text"
                    (keydown.space)="$event.preventDefault()"
                    [ngClass]="{
                      'is-invalid': add.email.touched && add.email.errors
                    }"
                  />
                  <mat-error *ngIf="add.email.touched && add.email.errors">
                    <span *ngIf="add.email.errors.required"
                      >Email id is required</span
                    >
                    <span *ngIf="add.email.errors.email">
                      <i class="fas fa-exclamation-triangle"></i>
                      Invalid Email
                    </span>
                  </mat-error>
                </mat-form-field>
                <mat-form-field
                  class="col-lg-6 col-md-6 col-sm-12"
                  appearance="outline"
                >
                  <mat-label
                    >Contact Number
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    type="text"
                    maxlength="10"
                    minlength="10"
                    oninput="this.value = this.value.replace(/[^0-9.]/g,'')"
                    placeholder="Enter Your contact Number"
                    formControlName="phone"
                    [ngClass]="{
                      'is-invalid': add.phone.touched && add.phone.errors
                    }"
                  />
                  <mat-error *ngIf="add.phone.touched && add.phone.errors">
                    <span *ngIf="add.phone.errors.required"
                      >Contact Number is required</span
                    >
                    <span *ngIf="add.phone.errors.pattern">
                      <i class="fas fa-exclamation-triangle"></i>
                      Contact Number is Invalid
                    </span>
                  </mat-error>
                </mat-form-field>
                <mat-form-field
                  class="col-lg-6 col-md-6 col-sm-12"
                  appearance="outline"
                >
                  <mat-label
                    >Select Incubator
                    <span class="text-danger">*</span></mat-label
                  >
                  <mat-select
                    formControlName="incubator"
                    (selectionChange)="selectIncubator($event.value)"
                    placeholder="Search Incubator Name"
                  >
                    <mat-option>
                      <ngx-mat-select-search
                        [formControl]="incubatorFilterCtrl"
                        placeholderLabel="Search Incubator Name"
                        noEntriesFoundLabel="Incubator not found"
                      ></ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                      *ngFor="let list of incubatorListValue | async"
                      [value]="list.incubatorId"
                    >
                      {{ list.incubatorName }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="add.incubator.touched && add.incubator.errors"
                  >
                    <span *ngIf="add.incubator.errors.required"
                      >Select Incubator is required</span
                    >
                  </mat-error>
                </mat-form-field>
                <mat-form-field
                  class="col-lg-6 col-md-6 col-sm-12"
                  appearance="outline"
                >
                  <mat-label
                    >Required Supports
                    <span class="text-danger">*</span></mat-label
                  >
                  <mat-select
                    formControlName="purpose"
                    multiple
                    [ngClass]="{
                      'is-invalid': add.purpose.touched && add.purpose.errors
                    }"
                  >
                    <mat-option *ngFor="let option of options" [value]="option">
                      {{ option }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="add.purpose.touched && add.purpose.errors">
                    <span *ngIf="add.purpose.errors.required"
                      >Select Supports is required</span
                    ></mat-error
                  >
                </mat-form-field>
                <mat-form-field
                  class="col-lg-12 col-md-12 col-sm-12 h-100"
                  appearance="outline"
                >
                  <mat-label
                    >Please share in brief about requirement
                    <span class="text-danger">*</span></mat-label
                  >
                  <textarea
                    matInput
                    #input
                    maxlength="100"
                    placeholder="Please share in brief about requirement"
                    name="note"
                    formControlName="message"
                    [ngClass]="{
                      'is-invalid': add.message.touched && add.message.errors
                    }"
                  >
                                   <span class="text-danger">*</span></textarea
                  >
                  <mat-hint align="end" style="float: left"
                    >{{ input.value.length }}/100</mat-hint
                  >
                  <mat-error *ngIf="add.message.touched && add.message.errors">
                    <span *ngIf="add.message.errors.required"
                      >Share in brief about required</span
                    ></mat-error
                  >
                </mat-form-field>
                <div class="d-flex justify-content-center" id="formbtn">
                  <button
                    class="btn btn-warning connect-btn"
                    type="button"
                    (click)="clearForm()"
                  >
                    Reset
                  </button>

                  <button
                    class="btn btn-warning connect-btn"
                    type="submit"
                    (click)="onSubmit()"
                  >
                    Submit
                  </button>
                </div>
                <div id="myModal" class="modal">
                  <div class="modal-content text-center">
                    <div class="text-center">
                      <img
                        style="width: 100px"
                        src="/assets/images/tick2.gif"
                        alt=""
                      />
                    </div>
                    <p
                      class="text-center"
                      style="padding: 20px; font-size: 20px"
                    >
                      <span style="font-size: 24px; font-weight: 500"
                        >Thank you for connecting with Incubator.</span
                      ><br />
                      <span style="font-size: 17px; color: gray"
                        >Incubator will get in touch with you shortly.</span
                      >
                    </p>
                    <div class="text-center">
                      <button class="incubatorBtn" (click)="closeModal()">
                        OK
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="gallery-section">
    <div class="text-center">
      <h1>Gallery</h1>
    </div>
    <marquee behavior="" direction="">
      <div class="d-flex">
        <div class="m-3" *ngFor="let list of gallerydisList; let i = index">
          <div class="image-main-div">
            <img [src]="list.galleryImageName" alt="" class="img-fluid" />
          </div>
          <div class="incubator-name text-center mt-3">
            <span>{{ list.galleryTags }}</span>
          </div>
        </div>
      </div>
    </marquee>
    <div class="div-contents" *ngIf="noData == true">
      <div class="text-center home-no-data-div">
        <img
          style="width: 550px"
          src="assets/images/new_logo.png"
          class="img-fluid"
          alt=""
        />
        <h6 style="color: #ffff">Coming soon</h6>
      </div>
    </div>
  </section>
  <section class="frequent-section">
    <div class="container">
      <div class="text-center">
        <h1>Frequently Asked Questions</h1>
      </div>
      <mat-accordion class="expent-card">
        <mat-expansion-panel class="mat-expendcard">
          <mat-expansion-panel-header class="expent-card-head">
            <mat-panel-description>
              1. What is a business incubator?
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>
            A business incubator is an organisation or program designed to
            support the development and growth of early-stage startups and
            entrepreneurs. They provide a range of resources, services, and
            support to help startups succeed.
          </p>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-expendcard">
          <mat-expansion-panel-header class="expent-card-head">
            <mat-panel-description>
              2. What types of support do business incubators offer?
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>
            Business incubators typically offer services such as mentorship,
            networking opportunities, access to funding, office space or
            coworking facilities, business development assistance, access to
            professional services (legal, accounting, etc.), and training
            programs.
          </p>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-expendcard">
          <mat-expansion-panel-header class="expent-card-head">
            <mat-panel-description>
              3. Who can benefit from a business incubator?
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>
            Business incubators are beneficial for early-stage startups and
            entrepreneurs who are in the initial stages of building their
            businesses. They provide valuable support, guidance, and resources
            to help startups overcome common challenges and accelerate their
            growth.
          </p>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-expendcard">
          <mat-expansion-panel-header class="expent-card-head">
            <mat-panel-description>
              4. Are there any fees associated with joining a business
              incubator?
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>
            Some business incubators may charge a fee for participation or for
            utilising certain services, while others may offer free or
            subsidised programs. It's essential to review the terms and
            conditions of each incubator to understand any associated costs.
          </p>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-expendcard">
          <mat-expansion-panel-header class="expent-card-head">
            <mat-panel-description>
              5. What criteria do business incubators use to select startups?
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>
            Business incubators evaluate startups based on various criteria,
            including the viability of the business idea, the potential for
            growth and scalability, the strength of the founding team, market
            potential, innovation, and the readiness for incubation support.
          </p>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-expendcard">
          <mat-expansion-panel-header class="expent-card-head">
            <mat-panel-description>
              6. What are the different types of Business Incubators?
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>
            Incubators are of different types based on their business model. The
            following are some of the well known models of business incubators,
            especially in Tamil Nadu,
          </p>
          <ul>
            <li>Technology Business Incubators (TBIs)</li>
            <li>Manufacturing Business Incubators (MBIs)</li>
            <li>Academic/Institutional Incubators</li>
            <li>Corporate Incubators</li>
            <li>Not for Profit Incubators</li>
            <li>For Profit Incubators</li>
            <li>Sector Specific Incubators</li>
            <li>Regional Incubators</li>
            <li>Social Incubators</li>
            <li>Design Incubators</li>
          </ul>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-expendcard">
          <mat-expansion-panel-header class="expent-card-head">
            <mat-panel-description>
              7. How to contact an Incubator through this portal?
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p class="mat-exp-cont">
            Any startup or an innovator can connect with any of the Tamil Nadu
            Incubator through the “Connect with Incubator” form available in the
            StartupTN Incubator portal’s home page. Applicants can choose an
            incubator, from the list of incubators and once submitted, the
            concerned incubator representative will call back. It is now that
            simple, to get connected with an Incubator in Tamil Nadu.
          </p>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-expendcard">
          <mat-expansion-panel-header class="expent-card-head">
            <mat-panel-description>
              8. What is CSR Spot?
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>
            CSR Spot is open for Corporates and Industries who are looking to
            explore CSR Projects. The main objective of CSR Spot is to encourage
            corporates to utilise Tamil Nadu Incubators for CSR through
            StartupTN. StartupTN motivates Corporates to join hands with us by
            submitting “Partner” registration form.
          </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </section>
  <app-footer></app-footer>
</main>
